module.exports = __webpack_public_path__ + "static/Muli-ExtraLightItalic.03a196db.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-ExtraLightItalic.ttf
// module id = 335
// module chunks = 114276838955818